import he from "he";
import parse, { domToReact } from "html-react-parser";
import moment from "moment/moment.js";
import * as XLSX from "xlsx";
//import { convertSelectOptType } from "./definitions.js";

export const formDataValueHandler = (
  formData: any,
  name: string,
  value: any,
  type: number
): void => {
  //type = 0 property
  //type = 1 object from id - name
  //type = 2 date
  //type = 3 selectValue from code
  //type = 4 objectList from id - name list
  //type = 5 phoneNumber unmasked
  formData.delete(name);
  if (value == null) return;
  switch (type) {
    case 0:
      formData.append(name, value);
      break;
    case 1:
      formData.append(`${name}[id]`, value?.id);
      formData.append(`${name}[name]`, value?.name);
      break;
    case 2:
      formData.append(name, moment(value).format("YYYY-MM-DDThh:mm:00.000Z"));
      break;
    case 3:
      formData.append(name, value?.code);
      break;
    case 4:
      Array.from(value).forEach((x: any, i) => {
        formData.append(`${name}[${i}][id]`, x?.id);
        formData.append(`${name}[${i}][name]`, x?.name);
      });
      break;
    default:
      formData.append(name, value);
      break;
  }
};

export const convertCharset = (value: any): string => {
  if (value == null) return "";
  const locales = ["tr", "TR", "tr-TR", "tr-u-co-search", "tr-x-turkish"];

  value = value
    .toString()
    .toLocaleLowerCase(locales)
    .replaceAll("İ", "i")
    .replaceAll("I", "i")
    .replaceAll("ç", "c")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ı", "i")
    .replaceAll("ö", "o")
    .replaceAll("ş", "s");
  return value;
};

export const convertCurrency = (value: any): string | null => {
  if (value === undefined || value.length === 0) return null;
  value = value.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
  return value;
};

export const convertFileBase64 = (
  file: File
): Promise<{ base64: string; preview: string | ArrayBuffer | null }> => {
  return new Promise((resolve, rejest) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (e) => {
      const base64 =
        typeof reader.result === "string"
          ? reader.result.replace("data:", "").replace(/^.+,/, "")
          : "";
      const preview = e.target?.result ?? null;
      resolve({ base64, preview });
    };
  });
};

export const getFileExtension = (filename: string): string => {
  const ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1];
};

export const downloadExcel = (
  dataSource: Array<Object>,
  sheetName: string,
  fileName: string
): boolean => {
  const ws = XLSX.utils.json_to_sheet(dataSource);
  const header = Object.keys(dataSource[0]);
  var wscols = [];
  for (let i = 0; i < header.length; i++) {
    wscols.push({ wch: header[i].length + 14 });
  }
  ws["!cols"] = wscols;
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFileXLSX(
    wb,
    `${fileName}-${getDayMonthYearNow(0)}.${getDayMonthYearNow(
      1
    )}.${getDayMonthYearNow(2)}-${Math.floor(Math.random() * 99999)}.xlsx`
  );
  return true;
};

export const getDayMonthYearNow = (value: any): string | number => {
  const date = new Date();
  switch (value) {
    case 0:
      return date.getDate().toString().padStart(2, "0");
    case 1:
      return (date.getMonth() + 1).toString().padStart(2, "0");
    case 2:
      return date.getFullYear();
    case 3:
      return `${getDayMonthYearNow(0)}${getDayMonthYearNow(
        1
      )}${getDayMonthYearNow(2)}`;
    default:
      return "";
  }
};

export const scrollTop = (): void => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

export const sliceText = (text: string, count: number): string => {
  if (text.length > count) {
    text = text.slice(0, parseInt(count.toString()) - 3);
    text = `${text}...`;
  }
  return text;
};

export const formatPhoneNumber = (phoneNumberString: string): string => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(90|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+90 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return phoneNumberString;
};

export const distinctArray = (array: any[]): any => {
  let map = new Map();
  array.forEach((value) => map.set(value, value));
  return [...map.values()];
};

export const generateRandomNumbers = (): string => {
  return Math.floor(Math.random() * 99999999999).toString();
};

export const convertSelectOpt = (
  data: any[] | null | undefined,
  type: any
): { name: any; id: any }[] | undefined => {
  if (data !== undefined && data !== null && data.length > 0) {
    const _tempData: { name: any; id: any }[] = [];
    /**
     * type = 0 User
     * type = 1 WithCompanyName
  
    switch (type) {
      case 0:
        data.forEach((x, i) => {
          _tempData.push({ name: x.fullName, id: x.id });
        });
        break;
      case convertSelectOptType.WithCompanyName:
        data.forEach((x, i) => {
          _tempData.push({ name: `${x.name} - ${x.company.name}`, id: x.id });
        });
        break;
      default:
        data.forEach((x, i) => {
          _tempData.push({ name: x.name, id: x.id });
        });
        break;
    }
    */

    return _tempData;
  }
};

export const downloadImage = async (
  imageSrc: string | URL | Request,
  fileName: { replaceAll: (arg0: string, arg1: string) => any }
): Promise<void> => {
  fileName = fileName.replaceAll(" ", "");
  fetch(imageSrc, {
    method: "get",
    mode: "cors",
  })
    .then((res) => res.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}QrCode.png`;
      a.click();
      URL.revokeObjectURL(url);
    });
};

export const formatDateForForm = (date: moment.MomentInput) => {
  if (date == null) return null;

  return moment(date).format("YYYY-MM-DDThh:mm:00.000Z");
};

export const codeDataFilter = (data: any[], filterVal: any): any => {
  return data.filter((item) => item.code === filterVal)[0];
};

export const onChangeForFormik = (
  formik: {
    handleChange: (arg0: { target: { name: any; value: any } }) => void;
  },
  item: { name: any },
  value: undefined,
  setFormData: any
): void => {
  formik.handleChange({
    target: {
      name: item.name,
      value: value !== undefined ? value : null,
    },
  });

  // setFormData((prev) => ({
  //   ...prev,
  //   name: value,
  // }));
  //
  // if (name === "company") {
  //   setFormData((prev) => ({
  //     ...prev,
  //     companySub: null,
  //     department: null,
  //     title: null,
  //     location: null,
  //   }));
  //   formik.setFieldValue("companySub", null);
  //   formik.setFieldValue("department", null);
  //   formik.setFieldValue("title", null);
  //   formik.setFieldValue("location", null);
  // }
  // if (name === "companySub") {
  //   setFormData((prev) => ({
  //     ...prev,
  //     department: null,
  //     title: null,
  //   }));
  //   formik.setFieldValue("department", null);
  //   formik.setFieldValue("title", null);
  // }
  // if (name === "department") {
  //   setFormData((prev) => ({
  //     ...prev,
  //     title: null,
  //   }));
  //   formik.setFieldValue("title", null);
  // }
};

export const unMask = (value: string): string | null => {
  if (value == null) return null;
  return value.replace(/[^\d]/g, "");
};

// ... existing code ...
// ... existing code ...
export const editorHeader = () => {
  return (
    <>
      <div id="toolbar" style={{position:"relative"}}>
        <span className="ql-formats">
          <select className="ql-font"></select>
          <select className="ql-size"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold"></button>
          <button className="ql-italic"></button>
          <button className="ql-underline"></button>
          <button className="ql-strike"></button>
        </span>
        <span className="ql-formats">
          <select className="ql-color"></select>
          <select className="ql-background"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-script" value="sub"></button>
          <button className="ql-script" value="super"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-header" value="1"></button>
          <button className="ql-header" value="2"></button>
          <button className="ql-blockquote"></button>
          <button className="ql-code-block"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-list" value="ordered"></button>
          <button className="ql-list" value="bullet"></button>
          <button className="ql-indent" value="-1"></button>
          <button className="ql-indent" value="+1"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-direction" value="rtl"></button>
          <select className="ql-align"></select>
        </span>
        <span className="ql-formats">
          <button className="ql-link"></button>
          <button className="ql-image"></button>
          <button className="ql-video"></button>
          <button className="ql-formula"></button>
          <button className="ql-code" title="Code Preview"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-clean"></button>
        </span>
      </div>
    </>
  );
};
// ... existing code ...
// ... existing code ...

export const fixQuillLists = (htmlContent: string) => {
  if (!htmlContent) return "";

  return (
    htmlContent
      // `data-list="bullet"` içeren `<ol>`'leri `<ul>` olarak değiştir
      .replace(/<ol>(\s*<li data-list="bullet".*?)<\/ol>/g, "<ul>$1</ul>")
      // Gereksiz `data-list` özniteliklerini temizle
      .replace(/<li data-list="bullet"/g, "<li")
      .replace(/<li data-list="ordered"/g, "<li")
      // Fazladan boşlukları kaldır
      .replace(/\r\n/g, "<br/>")
      .replace(/<p>&lt;iframe/g, "<p><iframe")
      .replace(/&lt;iframe/g, "<iframe")
      .replace(/&gt;&lt;\/iframe&gt;<\/p>/g, "></iframe></p>")
  );
};

export const richTextRenderer = (htmlContent: string) => {
  if (!htmlContent) return "";

  const decodedValue = he.decode(htmlContent);

  // Önce metin düzeltmelerini yap
  const cleanedHtml = decodedValue
    // `data-list="bullet"` içeren `<ol>`'leri `<ul>` olarak değiştir
    .replace(/<ol>(\s*<li data-list="bullet".*?)<\/ol>/g, "<ul>$1</ul>")
    // Gereksiz `data-list` özniteliklerini temizle
    .replace(/<li data-list="bullet"/g, "<li")
    .replace(/<li data-list="ordered"/g, "<li")
    // Fazladan boşlukları kaldır
    .replace(/\r\n/g, "<br/>")
    .replace(/<p>&lt;iframe/g, "<p><iframe")
    .replace(/&lt;iframe/g, "<iframe")
    .replace(/&gt;&lt;\/iframe&gt;<\/p>/g, "></iframe></p>");

  const options = {
    replace: (domNode: any) => {
      if (domNode.name === "iframe") {
        return (
          <iframe
            src={domNode.attribs.src}
            width={domNode.attribs.width || "560"}
            height={domNode.attribs.height || "315"}
            style={{ maxWidth: domNode.attribs.maxWidth || "90vw" }}
            title={domNode.attribs.title || "Video Player"}
            frameBorder="0"
            allow={
              domNode.attribs.allow ||
              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            }
            allowFullScreen
            referrerPolicy={
              domNode.attribs.referrerpolicy ||
              "strict-origin-when-cross-origin"
            }
          ></iframe>
        );
      }

      if (domNode.name === "a") {
        return (
          <a
            href={domNode.attribs.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {domToReact(domNode.children)}
          </a>
        );
      }

      if (domNode.name === "br") {
        // <br> tag'ini boş satır olarak render et
        return <br />;
      }

      return undefined;
    },
  };

  return <div className="alink">{parse(cleanedHtml, options)}</div>;
};
